<app-main-layout [clickNext]="onClickNext" [clickBack]="onClickBack" [activateNextButton$]="nextButtonState.activateNext$">
  <div class="checkmark-holder">
    <div class="ckeckmark-item">
      <img src="assets/icons/checkmark.svg" alt="">
    </div>
    <h2 class="center">{{hasDate ? appointmentDate : 'Your form is submitted!'}}</h2>
    <h4 class="center" [innerHtml]="hasDate ? subtitles[1] : subtitles[2]"></h4>
  </div>
  <div class="main-heading">
    <h4>Anything else we should know?</h4>
  </div>
  <form class="contact-form" [formGroup]="additionalCommentsForm">
    <app-form-group
      label="Comments"
      id="comments"
      formControlName="comments"
      placeholder="Please add additional comments here..."
      [textarea]="true"
      [counter]="3000"
      class="mb-24 d-block"
    ></app-form-group>
    @if (!isEvent) {
      <div>
        <h4 class="mb-24">Which of the following do you have questions about?</h4>
        <div class="topics-wrapper">
          @for (item of topics; track identify($index, item)) {
            <app-topic-button
              [text]="item.title"
              (onItemClick)="onSelectTopic(item)"
              [selected]="item.selected"
              class="child"
            ></app-topic-button>
          }
        </div>
      </div>
    }
  </form>
</app-main-layout>
